
export default class ObjectiveRatings {

    // public static GetRatings(objectiveIndex: number, properties?: any): number {
    //     switch (objectiveIndex) {
    //         case 0:
    //         case 1:
    //         case 4:
    //         case 5:
    //         case 8:
    //         case 9:
    //         case 11:
    //         case 15:
    //         case 18:
    //         case 19:
    //         case 22:
    //         case 23:
    //         case 25:
    //         case 26:
    //         case 27:
    //             return 3;
    //             break;

    //         case 2:
    //             if (properties.boundaries == 0) {
    //                 return 0;
    //             }
    //             else if (properties.boundaries <= 3)
    //                 return 1;
    //             else if (properties.boundaries <= 6)
    //                 return 2;
    //             else if (properties.boundaries > 6)
    //                 return 3;
    //             break;

    //         case 3:
    //             if (properties.runs == 0) {
    //                 return 0;
    //             }
    //             else if (properties.runs <= 5)
    //                 return 1;
    //             if (properties.runs <= 15)
    //                 return 2;
    //             if (properties.runs > 15)
    //                 return 3;
    //             break;

    //         case 6:
    //             if (properties.runs == 0) {
    //                 return 0;
    //             }
    //             else if (properties.sixes <= 3)
    //                 return 1;
    //             if (properties.sixes <= 6)
    //                 return 2;
    //             if (properties.sixes >= 7)
    //                 return 3;
    //             break;

    //         case 7:
    //             if (properties.runs == 0) {
    //                 return 0;
    //             }
    //             if (properties.boundaries <= 2)
    //                 return 1;
    //             else if (properties.boundaries <= 3)
    //                 return 2;
    //             else if (properties.boundaries > 3)
    //                 return 3;
    //             break;

    //         case 10:
    //             if (properties.balls == 1)
    //                 return 0;
    //             if (properties.balls <= 9)
    //                 return 1;
    //             if (properties.balls <= 19)
    //                 return 2;
    //             if (properties.balls > 20)
    //                 return 3;
    //             break;

    //         case 12:
    //             if (properties.runs <= 5)
    //                 return 1;
    //             if (properties.runs <= 15)
    //                 return 2;
    //             if (properties.runs > 15)
    //                 return 3;
    //             break;

    //         case 13:
    //             if (properties.boundaries <= 2)
    //                 return 1;
    //             else if (properties.boundaries <= 3)
    //                 return 2;
    //             else if (properties.boundaries > 3)
    //                 return 3;
    //             break;

    //         case 14:
    //             if (properties.sixes <= 3)
    //                 return 1;
    //             if (properties.sixes <= 5)
    //                 return 2;
    //             if (properties.sixes >= 6)
    //                 return 3;
    //             break;

    //         case 16:
    //             if (properties.boundaries <= 3)
    //                 return 1;
    //             else if (properties.boundaries <= 7)
    //                 return 2;
    //             else if (properties.boundaries > 7)
    //                 return 3;
    //             break;

    //         case 17:
    //             if (properties.runs <= 15)
    //                 return 1;
    //             if (properties.runs <= 30)
    //                 return 2;
    //             if (properties.runs > 30)
    //                 return 3;
    //             break;

    //         case 20:
    //             if (properties.sixes <= 3)
    //                 return 1;
    //             if (properties.sixes <= 6)
    //                 return 2;
    //             if (properties.sixes > 6)
    //                 return 3;
    //             break;

    //         case 21:
    //             if (properties.boundaries <= 3)
    //                 return 1;
    //             else if (properties.boundaries <= 6)
    //                 return 2;
    //             else if (properties.boundaries > 6)
    //                 return 3;
    //             break;

    //         case 24:
    //             if (properties.sixes <= 3)
    //                 return 1;
    //             if (properties.sixes <= 6)
    //                 return 2;
    //             if (properties.sixes > 6)
    //                 return 3;
    //             break;


    //         case 28:
    //             if (properties.boundaries <= 3)
    //                 return 1;
    //             else if (properties.boundaries <= 6)
    //                 return 2;
    //             else if (properties.boundaries > 6)
    //                 return 3;
    //             break;

    //         case 29:
    //             if (properties.sixes <= 3)
    //                 return 1;
    //             if (properties.sixes <= 6)
    //                 return 2;
    //             if (properties.sixes > 6)
    //                 return 3;
    //             break;
    //         case 30:
    //         case 31:
    //         case 32:
    //         case 33:
    //         case 34:
    //         case 35:
    //         case 36:
    //         case 37:
    //         case 38:
    //         case 39:
    //         case 40:
    //         case 41:
    //         case 42:
    //         case 43:
    //         case 44:
    //         case 45:
    //         case 46:
    //         case 47:
    //         case 48:
    //         case 49:
    //             return 3;
    //             break;

    //     }
    //     return 0;
    // }

    public static GetRatings(objectiveIndex: number, properties? : any): number {
        return 3;
    }
}